export default __webpack_public_path__ + "static/media/youtube.18749120.svg";